const serviceAreaData = [
  "Darbhanga Tower",
  "Benta",
  "Donar",
  "Kathalbari",
  "Allalpatti",
  "Sundarpur",
  "Shivdhara",
  "Bela",
  "Basudevpur",
  "Bahadurpur",
  "Kabirchak",
  "Balbhadrapur",
  "Bibi Pakar",
  "Kadirabad",
  "Maulaganj",
  "Karamganj",
  "Mirzapur",
  "Ekmi",
  "Lal Bagh",
  "Pator",
  "Mabbi",
  "Delhi More",
  "Naka No. 5",
  "Income Tax Chowk",
  "Donar Chowk",
  "Benta Chowk",
  "Khan Chowk",
  "Kathalbari Chowk",
  "Hospital Road",
  "VIP Road",
  "Aerodrome Area",
  "Raj Campus Area",
  "CM Science College Area"
];

export default serviceAreaData;